import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ActionButton from "./Button";

const useStyles = makeStyles(() => ({
  fullScreen: {
    "& .MuiDialog-paper": {
      maxWidth: "none", // Disable max-width to prevent X scrolling
      margin: 0, // Removes default margin for fullscreen effect
      height: "90%", // Full height for modal content
    },
    "& .MuiDialogTitle-root": {
      padding: "10px 20px",
    },
    "& .MuiDialogContent-root": {
      overflowY: "auto", // Ensures content is scrollable vertically if needed
    },
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
    color: "#000",
  },
}));

function SimpleDialog(props) {
  const classes = useStyles();
  const { open, onClose } = props;

  return (
    <Dialog
      className={classes.fullScreen}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-description"
      open={open}
      onClose={() => onClose(false)}
      fullWidth={true}
      PaperProps={{
        style: {
          width: props.width || "90%", // Set the custom width
          height: props.height || "90%",
          position: "relative",
          margin: "auto", // Ensure centering horizontally and vertically
        },
      }}
    >
      {props.modalTitleRequired && (
        <DialogTitle
          id="customized-dialog-title"
          style={{ background: "#fff" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ fontSize: "15px" }}>{props.modalTitle}</div>
            {!props.isNotRequiredCancelIcon && (
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={() => onClose(false)}
              >
                <CloseIcon />
              </IconButton>
            )}
          </div>
        </DialogTitle>
      )}
      <DialogContent
        style={{
          background: props.background,
          backgroundColor: props.backgroundColor,
          backgroundImage: props.backgroundImage,
          padding: props.padding || "20px",
          paddingTop: props.paddingTop || "10px",
        }}
      >
        <DialogContentText id="alert-dialog-description">
          {props.modalContent}
        </DialogContentText>
      </DialogContent>
      {props.modalFooterRequired && (
        <DialogActions>
          {props.buttonFooter && (
            <ActionButton
              buttonText={props.modalActionText}
              handleSubmit={props.handleSubmit}
              backgroundColor={"#ef6406"}
              color="#fff"
              border={"none"}
              width="120px"
            />
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function CustomModal(props) {
  return (
    <SimpleDialog
      modalContent={props.modalContent}
      modalTitleRequired={props.modalTitleRequired}
      modalFooterRequired={props.modalFooterRequired}
      handleSubmit={props.handleSubmit}
      modalActionText={props.modalActionText}
      open={props.open}
      onClose={props.handleClose}
      modalTitle={props.modalTitle}
      isNotRequiredCancelIcon={props.isNotRequiredCancelIcon}
      background={props.background}
      backgroundColor={props.backgroundColor}
      backgroundImage={props.backgroundImage}
      padding={props.padding}
      paddingTop={props.paddingTop}
      buttonFooter={props.buttonFooter}
      width={props.width}
      height={props.height}
    />
  );
}
